import { FileImageProperties } from "./file.type";
import { UserProperties } from "./user.type";

export enum ETagStatus {
	PUBLISH = "PUBLISH",
	UNPUBLISH = "UNPUBLISH",
}

export enum EPublishTypeArticle {
	PUBLISH_NOW = "PUBLISH_NOW",
	SCHEDULED = "SCHEDULED",
}

export interface TagProperties {
	tagId: string;
	tagName: string;
	status: ETagStatus;
	createdAt: Date;
	updatedAt: Date;
	deletedAt?: Date;
	totalPosts: number;
	articleTags: ArticleTagProperties[];
}

export interface ArticleTagProperties {
	articleTagId: string;
	articleId: string;
	tagId: string;
	createdAt: Date;
	updatedAt: Date;
	deletedAt: Date;

	article: ArticleProperties;
	tag: TagProperties;
}

export interface MasterArticleCategoryProperties {
	categoryId: string;
	categoryName: string;
	description?: string;
	status: EArticleCategoriesStatus;
	createdAt: Date;
	updatedAt: Date;
	deletedAt: Date;
	subCategories: MasterArticleSubCategoryProperties[];
	totalPosts: number;
}

export interface MasterArticleSubCategoryProperties {
	categoryId: string;
	parentCategoryId?: string;
	categoryName: string;
	description?: string;
	status: EArticleCategoriesStatus;
	createdAt: Date;
	updatedAt: Date;
	deletedAt: Date;
	parentCategory: MasterArticleCategoryProperties;
	totalPosts: number;
}

export enum EArticleCategoriesStatus {
	PUBLISH = "PUBLISH",
	UNPUBLISH = "UNPUBLISH",
}

export interface ArticleCategoryProperties {
	articleCategoryId: string;
	articleId: string;
	categoryId: string;
	parentCategoryId: string;
	createdAt: Date;
	updatedAt: Date;
	deletedAt: Date;

	article: ArticleProperties;
	category: MasterArticleSubCategoryProperties;
	parentCategory: MasterArticleCategoryProperties;
}

export interface ArticleProperties {
	articleId: string;
	title: string;
	authorName?: string;
	subtitle?: string;
	titleEn?: string;
	subtitleEn?: string;
	slug: string;
	slugEn?: string;
	categoryId: string;
	body: string;
	bodyEn: string;
	status: EArticleStatus;
	publishType: EPublishTypeArticle;
	createdByUserId: string;
	isHighlight: boolean;
	metaCreatedByUser: any;
	createdAt: Date;
	publicationAt?: Date | null;
	externalData?: any;
	updatedAt: Date;
	deletedAt?: Date;

	tags: ArticleTagProperties[];
	categories: ArticleCategoryProperties[];
	comments: ArticleCommentProperties[];

	images?: FileImageProperties[];
	user?: UserProperties;
}

export interface ArticleCommentProperties {
	commentId: string;
	articleId: string;
	name: string;
	email: string;
	comment: string;
	commentEn?: string;
	createdByUserId?: string;
	metaCreatedByUser?: any;
	isDeleted?: boolean;
	profilePic?: any;
	createdAt: Date;
	updatedAt: Date;

	replies: ArticleReplyCommentProperties[];
}

export interface ArticleReplyCommentProperties {
	replyId: string;
	commentId: string;
	name: string;
	email: string;
	comment: string;
	commentEn?: string;
	createdByUserId?: string;
	metaCreatedByUser?: any;
	isDeleted?: boolean;

	profilePic?: any;

	createdAt: Date;
	updatedAt: Date;
}

export interface ArticleSharedProperties {
	contentSharedId: string;
	contentId: string;
	socialMedia: string;
	originURL: string;
}

export interface ArticleSharedCountProperties {
	totalCount: number; 
	socialMediaCounts: Record<string, number>;
}

export enum EArticleStatus {
	PUBLISH = "PUBLISH",
	NEED_APPROVAL = "NEED_APPROVAL",
	SCHEDULED = "SCHEDULED",
	OPEN = "OPEN",
	UNPUBLISH = "UNPUBLISH",
}

export interface ListArticlesQuery {
	status?: EArticleStatus;
	isArchive?: string;
	sort?: string;
	userIds?: string | undefined;
	authorName?: string;
	authorUserIds?: string;
}

export interface ListCategoriesQuery {
	status?: EArticleCategoriesStatus;
}

export interface ListArticleSharedQuery {
	contentType: string;
	contentId: string;
	refId1: string;
	refId2: string;
	refId3: string;
}

export enum EArticleCommentStatus {
	PUBLISH = "PUBLISH",
	WAITING_APPROVAL = "WAITING_APPROVAL",
	REJECTED = "REJECTED",
}

export enum EArticleReplyStatus {
	PUBLISH = "PUBLISH",
	WAITING_APPROVAL = "WAITING_APPROVAL",
	REJECTED = "REJECTED",
}

export interface ListCommentQuery {
	articleIds?: string;
	status?: string;
	sort?: string;
}
